export enum PersonalizationId {
    WashingHandMade = 'hand-wash',
    WashingSpecialistCenters = 'specialized-center-wash',
    MaintenancePackages = 'maintenance-pack',
    TechnicalInspection = 'technical-inspection',
    PreMot = 'pre-mot',
    PreMot360 = '360-pre-mot',
    MotHomologation = 'mot-homologation',
    Itv = 'mot-fuel-car-es',
    ItvDiesel = 'mot-diesel-car-es',
    Itv360 = '360-mot-fuel-car-es',
    ItvDiesel360 = '360-mot-diesel-car-es',
    ItvMotorcycle = 'mot-motorbike-es',
    ItvMotorcycle360 = '360-mot-motorbike-es',
    ItvccMotorcycle = 'mot-motorbike-125cc-es',
    ItvccMotorcycle360 = '360-mot-motorbike-125cc-es',
    TowTruck = 'tow_truck',
    Parking = 'parking',
    Tyres = 'tyres',
    OwnershipChange = 'ownership-change',
    Refuel = 'refueling-car-topping',
    OpenForm = 'open-form',
    Valet = 'valet-station',
    MediumLongDistanceTranfer = 'medium-long-distance',
    Transfer = 'transfer',
    Transit = 'transit',
    TransferReplacementVehicle = 'transfer-replacement-vehicle',
    TransferClientPickUp = 'collect',
    TransferClientDelivery = 'return',
  }